import { render, staticRenderFns } from "./HelpThirdPage.vue?vue&type=template&id=52aa3128&"
import script from "./HelpThirdPage.vue?vue&type=script&lang=js&"
export * from "./HelpThirdPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports